// src/helpers/factories/menuDiscountCardFactory.ts
var menuDiscountCardFactory = (discounts) => {
  return Object.values(discounts).map((discount) => {
    const isActive = discount.active;
    return {
      id: discount.discountId,
      title: discount.name,
      isActive,
      activeFilter: isActive ? 1 : 2
    };
  });
};

export { menuDiscountCardFactory };
